import React, { createContext, useState, useContext, useEffect } from 'react';

const ChatPanelContext = createContext();

export const useChatPanel = () => useContext(ChatPanelContext);

export const ChatPanelProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(() => {
    const saved = sessionStorage.getItem("chatPanelIsOpen");
    return saved === "true";
  });
    const [isMinimized, setIsMinimized] = useState(false);
  const [isEdgeMode, setIsEdgeMode] = useState(false);
  const [showEdgeStrip, setShowEdgeStrip] = useState(false);
  const [isMaximized, setIsMaximized] = useState(() => {
    const saved = sessionStorage.getItem("chatPanelIsOpen");
    return saved !== "false"; 
  });
  useEffect(() => {
    sessionStorage.setItem("chatPanelIsOpen", isOpen);
  }, [isOpen]);
  const openPanel = () => {
    setIsOpen(true);
    setIsMinimized(false);
    setIsEdgeMode(false);
    setShowEdgeStrip(false);
  };

  const closePanel = () => {
    setIsOpen(false);
    setIsEdgeMode(false);
    setShowEdgeStrip(false);
  };

  const togglePanel = () => {
    if (showEdgeStrip) {

      setIsOpen(true);
      setIsEdgeMode(true);
      setShowEdgeStrip(false);
    } else if (isEdgeMode) {
      setIsOpen(!isOpen);
    } else {
      setIsOpen(prev => !prev);
    }
  };

  const maximizePanel = () => {
    setIsMaximized(true);
  };

  const restoreFromMaximize = () => {
    setIsMaximized(false);
  };

  const toggleMaximizePanel = () => {
    setIsMaximized(prev => !prev);
  };

  const minimizePanel = () => {
    setIsMinimized(true);
  };

  const restorePanel = () => {
    setIsMinimized(false);
  };

  const openPanelFromEdge = () => {

    setShowEdgeStrip(true);
    setIsEdgeMode(false);
    setIsOpen(false);
    setIsMinimized(false);
  };

  const closeEdgeMode = () => {
    setIsEdgeMode(false);
    setIsOpen(false);
    setIsMinimized(false);
    setShowEdgeStrip(false);
  };

  const openFromEdgeMode = () => {

    setIsOpen(true);
    setIsEdgeMode(true);
    setIsMinimized(false);
    setShowEdgeStrip(false);
  };

  const closeEdgeStrip = () => {
    setShowEdgeStrip(false);
  };

  return (
    <ChatPanelContext.Provider value={{
      isOpen,
      isMinimized,
      isMaximized,
      isEdgeMode,
      showEdgeStrip,
      openPanel,
      closePanel,
      togglePanel,
      minimizePanel,
      restorePanel,
      openPanelFromEdge,
      closeEdgeMode,
      openFromEdgeMode,
      closeEdgeStrip,
      maximizePanel,
      restoreFromMaximize,
      toggleMaximizePanel
    }}>
      {children}
    </ChatPanelContext.Provider>
  );
};